import React from 'react';
import { IVisitorScanBadgeStepProps } from './types';
import QrCodeReader from '../../../qrCodeReader';
import useStepper from '../../../stepper/useStepper';

const VisitorScanBadgeStep: React.FC<IVisitorScanBadgeStepProps> = ({
  onSuccess,
}) => {
  const { showNext } = useStepper();

  const handleSuccess = (badgeNumber: string) => {
    onSuccess(badgeNumber);
    showNext();
  };

  return <QrCodeReader backUrl="/visitor" onSuccess={handleSuccess} />;
};

export default VisitorScanBadgeStep;
